import { render, staticRenderFns } from "./SummaryDocumentHeaders.vue?vue&type=template&id=863f1574&scoped=true&"
import script from "./SummaryDocumentHeaders.vue?vue&type=script&lang=js&"
export * from "./SummaryDocumentHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863f1574",
  null
  
)

export default component.exports